import { useContext } from "react";
import { AlertDialogContext } from "./AlertDialogProvider";

// **Custom Hook**
export const useAlertDialog = () => {
    const context = useContext(AlertDialogContext);
    if (!context) {
      throw new Error("useAlertDialog 必須在 AlertDialogProvider 內使用");
    }
    return context;
};